import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { APP_CONST } from "../../../../config/const";
import { useSelector } from "react-redux";
import { socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import AppIframe from "../../../components/AppIframe";
import qs from "qs";

const DynamicSports = ({ provider: providerProp }) => {
  const provider = useParams()?.provider || providerProp;
  const { token } = useSelector((state) => state.auth);
  const [iframeUrl, setIframeUrl] = useState("");
  const socket = socketFunc(token);

  useEffect(() => {
    const decodedParams = decodeURIComponent(window.location.href);
    const parsedValues = qs.parse(decodedParams.split("?")?.[1] || "");
    getLobby(parsedValues);
  }, [provider]);

  const getLobby = (params) => {
    socket.emit(
      "get:sports_lobby",
      {
        providerCode: provider?.toUpperCase(),
        ...params,
      },
      (res) => {
        if (res?.status === "failed") {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res.message);
        }
        if (res?.status === "success") {
          handleResponse(res);
        }
      }
    );
  };

  const handleResponse = (value) => {
    if (value?.data && typeof value?.data === "string") {
      setIframeUrl(value?.data);
    } else if (value?.data && "lobbyUrl" in value?.data?.data) {
      setIframeUrl(value?.data?.data?.lobbyUrl);
    } else {
      setIframeUrl("");
    }
  };

  return (
    <>
      <div className="live_casino_page live">
        <div className="header-bg"></div>

        <AppIframe
          iframeUrl={iframeUrl}
          isRedirectionRequired={false}
          style={{
            width: "100%",
            height: "calc(100vh - 106px)", 
          }}
        />

        <div>{/* <BottomNav /> */}</div>
      </div>
    </>
  );
};
export default DynamicSports;
